import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import { mq } from '@sthzg/sthzgnet-base';
import StripedHeadline from '../StripedHeadline';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mq.small(css`
    flex-direction: row;
  `)};
`;

const Content = styled.div`
  width: 100%;
  order: 1;
  ${mq.small(css`
    width: 60%;
    order: 0;
  `)};
`;

const BaseHeadline = ({ className }) => (
  <StripedHeadline className={className} tokens={'Infrequently Asked Questions'.split(' ')} />
);
BaseHeadline.propTypes = {
  className: PropTypes.string.isRequired,
};

const Headline = styled(BaseHeadline)`
  width: 100%;
  ${mq.small(css`
    width: 40%;
    text-align: right;
    order: 1;
  `)};
`;

const IFAQ = () => (
  <Wrapper>
    <Headline />
    <Content>
      <h3>Where is the Blog?</h3>
      <p>
        Glad you asked, I miss it too. That&apos;s why the first part in the relaunch is lifting the
        old blog posts to the new system and bringing the content back online as soon as possible.
      </p>
      <h3>Will Learned Today! and the Glossary come back?</h3>
      <p>
        Absolutely, although their frontends and backends will be revamped to run as two separate
        services.
      </p>
    </Content>
  </Wrapper>
);

export default IFAQ;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/IFAQ/IFAQ.jsx